function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPointFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-point-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.99994 4C6.3918 3.99998 6.77503 4.11507 7.10204 4.33099C7.42905 4.54691 7.68542 4.85413 7.83931 5.21451C7.99321 5.57488 8.03784 5.97253 7.96768 6.35806C7.89751 6.74358 7.71563 7.1 7.44463 7.38304C7.17363 7.66609 6.82545 7.86328 6.44334 7.95014C6.06123 8.03699 5.66202 8.00968 5.2953 7.87159C4.92857 7.73351 4.6105 7.49073 4.38057 7.17341C4.15065 6.8561 4.01901 6.47823 4.002 6.08674L4 5.99994L4.002 5.91314C4.02437 5.39826 4.24464 4.91188 4.61687 4.55545C4.98911 4.19901 5.48457 4.00003 5.99994 4Z",
    fill: "#667085",
    style: {
      fill: "#667085",
      fill: "color(display-p3 0.4009 0.4408 0.5207)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPointFilled);
export default __webpack_public_path__ + "static/media/icon-point-filled.2d60535018b942d72f62ed73d0eecad8.svg";
export { ForwardRef as ReactComponent };